import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import { DpInterestChargesMapper } from "@domains/mapper/Reports/DpInterest/DpInterestCharges";
import { DpInterestDetailsMapper } from "@domains/mapper/Reports/DpInterest/DpInterestDetails";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class DpInterestRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getDpInterestCharges(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.dpURL + "/cash");
        url.searchParams.append("accountCode", req.accountCode);
        url.searchParams.append("fromDate", req.fromDate);
        url.searchParams.append("toDate", req.toDate);
        url.searchParams.append("dpType", req.dpType);
        const charges = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        return DpInterestChargesMapper(charges.data);
    }
    async getDpInterestDetails(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.dpURL + "/cash/detail");
        if (req.accCode)
            url.searchParams.append("accountCode", req.accCode);
        else
            url.searchParams.append("accountCode", accountCode);
        url.searchParams.append("dpType", req.dpType);
        url.searchParams.append("month", req.month);
        const details = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        return DpInterestDetailsMapper(details.data);
    }
}
export default DpInterestRepository;
